// src/views/contasPagar/PagamentoModal.jsx
import React, { useState, useEffect } from "react";
import contasBancariasService from "../../services/contasBancariasService";

const fmtMoeda = v => parseFloat(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
const fmtDt    = dt => { if(!dt)return"-"; try{return new Date((String(dt||"").split("T")[0])+"T12:00:00").toLocaleDateString("pt-BR");}catch{return dt;} };

export default function PagamentoModal({show,onClose,onPagar,parcela,saving=false,idCondominio}){
  const [form,setForm]=useState({tpPagamento:"PIX",idContaBancaria:"",chavePix:"",vlrPago:"",dtPagamento:new Date().toISOString().split("T")[0],observacao:""});
  const [contasBancarias,setContasBancarias]=useState([]);
  const [contaSel,setContaSel]=useState(null);

  useEffect(()=>{
    if(!idCondominio)return;
    contasBancariasService.listar({idCondominio,situacao:"ativo"}).then(r=>setContasBancarias(r.data||[])).catch(()=>{});
  },[idCondominio]);

  useEffect(()=>{
    if(!show||!parcela)return;
    setForm({tpPagamento:"PIX",idContaBancaria:parcela.idContaBancaria||"",chavePix:"",vlrPago:parcela.vlrParcela||"",dtPagamento:new Date().toISOString().split("T")[0],observacao:""});
    setContaSel(null);
  },[show,parcela]);

  const set=(f,v)=>setForm(p=>({...p,[f]:v}));

  const handleContaChange=(id)=>{
    set("idContaBancaria",id);
    const cb=contasBancarias.find(c=>String(c.id)===String(id));
    setContaSel(cb||null);
    if(cb?.chavePix && form.tpPagamento==="PIX") set("chavePix",cb.chavePix);
  };

  const handlePagar=()=>{
    if(!form.vlrPago||parseFloat(form.vlrPago)<=0)return alert("Informe o valor pago.");
    if(!form.dtPagamento)return alert("Informe a data do pagamento.");
    if(!form.idContaBancaria)return alert("Informe a conta bancária para o pagamento.");
    onPagar(parcela.id, form);
  };

  if(!show||!parcela)return null;

  const temConfigPix=contaSel?.pixClientId;

  return(
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{background:"#166534"}}>
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}><i className="bi bi-cash-coin" style={{fontSize:18,color:"#fff"}}/></div>
              <div><h5 className="modal-title mb-0">Pagar Parcela</h5><small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>Parcela {parcela.nrParcela} — Venc. {fmtDt(parcela.dtVencimento)}</small></div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>
          <div className="modal-body">
            {/* Info da parcela */}
            <div style={{background:"var(--bg-success-soft)",border:"1px solid #BBF7D0",borderRadius:8,padding:"12px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
              <div>
                <div style={{fontSize:12,color:"var(--gray-500)"}}>Fornecedor</div>
                <div style={{fontWeight:600,fontSize:14}}>{parcela.nmFornecedor||"—"}</div>
              </div>
              <div>
                <div style={{fontSize:12,color:"var(--gray-500)"}}>Descrição</div>
                <div style={{fontWeight:500,fontSize:13}}>{parcela.descricao||"—"}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:12,color:"var(--gray-500)"}}>Valor da Parcela</div>
                <div style={{fontWeight:700,fontSize:20,color:"#166534"}}>{fmtMoeda(parcela.vlrParcela)}</div>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-credit-card"/> Dados do Pagamento</div>
              <div className="row g-3">
                <div className="col-md-4"><label className="form-label">Forma de Pagamento</label>
                  <select className="form-select" value={form.tpPagamento} onChange={e=>set("tpPagamento",e.target.value)}>
                    {["PIX","Transferencia","TED","DOC","Cheque","Dinheiro","DebitoAutomatico","Outro"].map(t=><option key={t} value={t}>{t.replace(/([A-Z])/g," $1").trim()}</option>)}
                  </select>
                </div>
                <div className="col-md-4"><label className="form-label">Conta Bancária (débito)</label>
                  <select className="form-select" value={form.idContaBancaria} onChange={e=>handleContaChange(e.target.value)}>
                    <option value="">— Selecione —</option>
                    {contasBancarias.map(c=><option key={c.id} value={c.id}>{c.nmConta} — {fmtMoeda(c.saldoAtual)}</option>)}
                  </select>
                </div>
                <div className="col-md-4"><label className="form-label">Valor Pago <span className="required-mark">*</span></label>
                  <div className="input-group"><span className="input-group-text" style={{background:"var(--bg-success-soft)",color:"#166534",fontWeight:700}}>R$</span>
                    <input className="form-control" type="number" step="0.01" min="0.01" value={form.vlrPago} onChange={e=>set("vlrPago",e.target.value)}/>
                  </div>
                </div>
                <div className="col-md-4"><label className="form-label">Data do Pagamento <span className="required-mark">*</span></label>
                  <input type="date" className="form-control" value={form.dtPagamento} onChange={e=>set("dtPagamento",e.target.value)}/>
                </div>

                {form.tpPagamento==="PIX"&&(
                  <div className="col-md-12">
                    <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"12px 16px"}}>
                      <div style={{fontWeight:600,fontSize:13,color:"var(--primary)",marginBottom:10}}><i className="bi bi-qr-code me-2"/>Configuração PIX</div>
                      <div className="row g-2">
                        <div className="col-md-6"><label className="form-label" style={{fontSize:12}}>Chave PIX do Beneficiário</label>
                          <input className="form-control" value={form.chavePix} onChange={e=>set("chavePix",e.target.value)} placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"/>
                          {parcela.pixFornecedor&&<small style={{fontSize:11,color:"var(--gray-400)"}}>Cadastrado no fornecedor: {parcela.pixFornecedor}</small>}
                        </div>
                        <div className="col-md-6 d-flex align-items-end">
                          {temConfigPix
                            ?<div style={{background:"var(--bg-success-soft)",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#166534"}}><i className="bi bi-check-circle me-1"/>Conta configurada para PIX via API bancária</div>
                            :<div style={{background:"var(--bg-warning-soft)",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#854D0E"}}><i className="bi bi-exclamation-triangle me-1"/>Conta sem credenciais PIX. Registre o pagamento manualmente após realizar o PIX.</div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-12"><label className="form-label">Observações</label>
                  <textarea className="form-control" rows={2} value={form.observacao} onChange={e=>set("observacao",e.target.value)}/>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-between">
            <div style={{fontSize:12,color:"var(--gray-400)"}}>{contaSel&&<span>Saldo atual: <strong style={{color:parseFloat(contaSel.saldoAtual)>=parseFloat(form.vlrPago||0)?"#166534":"#991B1B"}}>{fmtMoeda(contaSel.saldoAtual)}</strong></span>}</div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-success" onClick={handlePagar} disabled={saving}>
                {saving?<><span className="spinner-border spinner-border-sm me-2"/>Processando...</>:<><i className="bi bi-check-circle"/> Confirmar Pagamento</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
